export default {
  BuildWxShare: 'Account/Share.BuildWxShare'
}